import dayjs from 'dayjs'

// Readings window for the temperature-series POST. ORDERS filters with ExternalInsertionDate BETWEEN
// @StartDate AND @EndDate, so a date-only endDate ("2026-09-27") binds as midnight and drops every
// reading taken today. endDate is therefore the current instant in UTC.
export const buildTemperatureWindow = (validFrom: string | undefined, now: Date = new Date()) => ({
  startDate: dayjs(validFrom ?? now).subtract(30, 'day').format('YYYY-MM-DD'),
  endDate: now.toISOString(),
})
